import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveSchoolDataThunk } from "../../../../shared/store/redux/auth-actions";
import { isValidUrl } from "../../../../shared/utils/utils";
import ImageUpload from "../../../../shared/components/ui/imageUpload/ImageUpload";
import ImageDisplayOptions from "./imageDisplayOptions/ImageDisplayOptions";
import SaveButton from "../shared/saveButton/SaveButton";
import classes from "./SchoolImageSection.module.css";

const SchoolImageSection = () => {

    const { texts } = useSelector((state) => state.translate);
    const { loading } = useSelector((state) => state.auth);
    const [imageFile, setImageFile] = useState();
    const [imageLink, setImageLink] = useState("");
    const [isImageButton, setIsImageButton] = useState(false);
    const schoolData = useSelector((state) => state.auth?.userDetails?.defaultSchool);
    const schoolId = schoolData?.id;
    const dispatch = useDispatch();

    useEffect(() => {
        if (schoolData) {
            setImageLink(schoolData.imageLink ?? "");
            setIsImageButton(!!schoolData.imageLink);
        }
    }, [schoolData]);

    const hasChanges = () => {
        return imageFile !== undefined ||
            imageLink !== (schoolData?.imageLink ?? "") ||
            isImageButton !== !!schoolData?.imageLink;
    }

    const buildFormData = () => {
        const formData = new FormData();
        formData.append("schoolId", schoolId);

        if (imageFile instanceof File)
            formData.append("imageFile", imageFile);
        else {
            const imageUrl = imageFile === null ? "" : schoolData?.imageUrl ?? "";
            formData.append("imageUrl", imageUrl);
        }
        formData.append("iconUrl", schoolData?.iconUrl ?? "");
        formData.append("imageLink", isImageButton ? imageLink : "");
        return formData;
    };

    const handleSave = async () => {
        if (!schoolId) return;
        if (isImageButton && imageLink && !isValidUrl(imageLink))
            return;
        const result = await dispatch(saveSchoolDataThunk(buildFormData()));
        if (result) {
            setImageFile(undefined);
        }
    };

    const handleImageDelete = () => {
        setImageFile(null);
    };

    return (
        <div className={classes.Section}>
            <h2 className={classes.SectionTitle}>{texts.schoolImageTitle}</h2>
            <p className={classes.DisplayOptionsLabel}>{texts.displayOptions}</p>
            <ImageDisplayOptions
                isImageButton={isImageButton}
                onIsImageButtonChange={setIsImageButton}
                imageLink={imageLink}
                onImageLinkChange={setImageLink}
            />
                <ImageUpload
                    imageFile={imageFile === undefined ? schoolData?.imageUrl ?? null : imageFile}
                    onImageChange={setImageFile}
                    onRemove={handleImageDelete}
                    removeAriaLabel={texts.delete}
                    maxSizeBytes={200 * 1024}
                    bannerKey="imageUploadDimensions"
                    size={250}
                />

            <SaveButton
                onClick={handleSave}
                disabled={!hasChanges() || loading}
            />
        </div>
    );
};

export default SchoolImageSection;
